import {
  PaymentStatus,
  getPaymentStatus,
  isPaymentComplete,
} from '@arc/unified-payments-frontend/shared-payment';
import { createSelector } from '@ngrx/store';
import { selectTransactionAuthorizationResultsList } from './btpay.selectors';

export const selectPaymentStatus = createSelector(
  selectTransactionAuthorizationResultsList,
  (transactionResults): PaymentStatus => getPaymentStatus(transactionResults),
);

export const selectIsPaymentSuccess = createSelector(
  selectPaymentStatus,
  (status) =>
    [
      PaymentStatus.SUCCESS,
      PaymentStatus.SOME_FAILED,
      PaymentStatus.SOME_PROCESSING,
    ].includes(status),
);

export const selectIsPaymentTimeout = createSelector(
  selectPaymentStatus,
  (status) => status === PaymentStatus.TIMEOUT,
);

export const selectIsPaymentComplete = createSelector(
  selectPaymentStatus,
  (status) => isPaymentComplete(status),
);

export const selectIsPaymentFailed = createSelector(
  selectPaymentStatus,
  (status) => status === PaymentStatus.FAILED,
);

export const selectPaymentAuthorizationError = createSelector(
  selectTransactionAuthorizationResultsList,
  (results) =>
    results.find((result) => result.errorMessage != null)?.errorMessage,
);
